import z from "zod";
import { KnownContentfulEnvironment } from "../types";
import { Locale } from "../locale";
import { RoleProps } from "contentful-management";

export const LocaleRole = z.custom<`LocaleSpecificEditor-${string}`>((data) => {
  const asString = z.string().parse(data);

  const [prefix, ...rest] = asString.split("-");
  const localeSuffix = Locale.parse(rest.join("-"));

  return prefix === "LocaleSpecificEditor" && localeSuffix;
});

export const EsportLocaleRole =
  z.custom<`LocaleSpecificEsportEditor-${string}`>((data) => {
    const asString = z.string().parse(data);

    const [prefix, ...rest] = asString.split("-");
    const localeSuffix = Locale.parse(rest.join("-"));

    return prefix === "LocaleSpecificEsportEditor" && localeSuffix;
  });

export const RoleType = z
  .enum([
    "CommunityManager",
    "StagingAccess",
    "EsportsManager",
    "CommunityTabAdmin",
    "TagEditor",

    // These two are deprecated, but we need to keep them around to keep the compiler happy...
    "CommunityManagerWithPublish",
    "CommunityManagerWithoutPublish",
  ])
  .or(LocaleRole)
  .or(EsportLocaleRole);

export type RoleType = z.infer<typeof RoleType>;

export type Role = {
  type: RoleType;
  name: string;
  description: string;
  policies: RoleProps["policies"];
  permissions: RoleProps["permissions"];
};

export const STAGING: KnownContentfulEnvironment = "staging";
export const MASTER: KnownContentfulEnvironment = "master";
